import { bundleStrikethroughPrice } from 'src/componentsV2/MenuBundleCard/utils'
import {
  CHEF_SKU_PROMOTION,
  SIDE_PROMOTION_TYPE
} from 'src/hooks/useMenuPromotion'
import { isAddOn } from 'src/modules/MyPlan/utils'
import { formatFixedPrice } from 'src/utils/utils'

export const getMealPriceByBox = (prices: any[], box: any): any => {
  if (!prices || prices.length === 0) return null

  const boxId = box.boxId
  const boxType = `BOX_${boxId}`
  const mealBoxPrice = prices.find(price => price.type === boxType)

  return mealBoxPrice ?? null
}

interface StrikethroughPriceParams {
  meal: any
  menuPromotion: any
  planIsCompleted: boolean
  isBundle?: boolean
}

export const getStrikethroughPrice = ({
  meal,
  menuPromotion,
  planIsCompleted,
  isBundle = false
}: StrikethroughPriceParams): string | null => {
  // Handle bundle case first
  if (isBundle) {
    return bundleStrikethroughPrice(meal, planIsCompleted)
  }

  // Handle regular meal promotions
  if (!menuPromotion) {
    return null
  }

  if (menuPromotion.type === SIDE_PROMOTION_TYPE) {
    return formatFixedPrice(meal.price)
  }

  if (
    menuPromotion.type === CHEF_SKU_PROMOTION &&
    (planIsCompleted || isAddOn(meal))
  ) {
    return formatFixedPrice(meal.price)
  }

  return null
}
